// https://material.io/design/communication/data-formats.html

export const formatDateTime = function (input, options = {}) {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function startOfDay(date) {
    let copy = new Date(date.getTime());
    copy.setHours(0, 0, 0, 0);
    return copy;
  }

  function endOfDay(date) {
    let copy = new Date(date.getTime());
    copy.setHours(23, 59, 59, 999);
    return copy;
  }

  const today = startOfDay(new Date());
  const inputDay = startOfDay(input);
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);


  // If the day is in the past or future within the current calendar year, display the abbreviated date.
  if (options.year !== true && input.getFullYear() === today.getFullYear()) {
    options.year = false;
  }

  // If the day is yesterday or tomorrow, use those terms.
  if (input > startOfDay(yesterday) && input < endOfDay(tomorrow)) {
    options.date = !(today.getTime() === inputDay.getTime());
    if (options.date) {
      options.isYesterday = (inputDay.getTime() === startOfDay(yesterday).getTime());
      options.isTomorrow = (inputDay.getTime() === startOfDay(tomorrow).getTime());
    }
  }

  let dateString = '';
  if (options.date !== false) {
    if (options.isYesterday) {
      dateString = 'Yesterday';
    } else if (options.isTomorrow) {
      dateString = 'Tomorrow';
    } else {
      dateString += `${monthNames[input.getMonth()]} ${input.getDate()}`;
      if (options.year !== false) {
        dateString += `, ${input.getFullYear()}`;
      }
    }
  }

  let timeString = '';
  if (options.time !== false) {
    timeString = input.toLocaleTimeString([], {hour12: true, hour: '2-digit', minute: '2-digit'})
  }

  return `${dateString}${(dateString ? ', ' : '')}${timeString}`;
};